

















import { Facet, Filter } from '@empathy/search-types';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { Facets } from '../../../models';
import { SUBMODULES_PATHS } from '../../../store';
import AddClassToSlot from '../add-class-to-slot';

@Component({
  components: {
    AddClassToSlot
  },
  computed: {
    ...mapState(SUBMODULES_PATHS.search, ['preSelectedFilters', 'query'])
  }
})
export default class FallbackFacet extends Vue {

  @Prop({ required: true })
  facet: Facet;

  @Prop({ default: 100 })
  filtersToShow: number;

  preSelectedFilters: Facets;
  query: string;

  get messageParams() {
    const preSelectedFacet = this.preSelectedFilters[this.facet.modelName];
    const selectedFilter = preSelectedFacet.filters.find(filter => filter.selected);
    return {
      facetName: this.$x.messages.facets.titles[this.facet.modelName],
      filter: selectedFilter.title,
      query: this.query
    };
  }

  get filters(): Filter[] {
    return Array.from(this.facet.filters)
      .filter(f => f.count)
      .sort((f1, f2) => f2.count - f1.count)
      .slice(0, this.filtersToShow);
  }

  get renderFallbackFacet(): boolean {
    return !!this.filters.length;
  }
}
